<div #headercontainer *ngIf="dataLoaded && headerData && headerData.visible && headerData.visible() && !isModal">
  <!-- <dossierHeader [projectId]="headerData.project ? headerData.project.identifier : null" [title]="headerData.taskDescription | translate" [titleIcon]="getTaskIcon()" [infoVisible]="headerData.infoVisible"> -->
  <dossierHeader *ngIf="headerData.project" [projectId]="headerData.project.identifier" [division]="headerData.division"
    [infoVisible]="headerData.infoVisible" [showDocumentsVisible]="headerData.showDocumentsVisible"
    [showCalendarVisible]="headerData.showCalendarVisible"></dossierHeader>
  <dossierHeader *ngIf="!headerData.project" [infoVisible]="headerData.infoVisible"
    [showDocumentsVisible]="headerData.showDocumentsVisible" [showCalendarVisible]="headerData.showCalendarVisible">
  </dossierHeader>
  <div class="titleHeader">
    <div class="title">
      <div>
        <div class="titleText text-ellipsis">
          <i class="fa fa-lg d-none d-sm-inline" [ngClass]="getTaskIcon()" aria-hidden="true"></i>
          <span> {{ headerData.taskDescription | translate }} </span>
        </div>
      </div>
    </div>
    <div class="buttonsHeader">
      <ng-container *ngFor="let button of headerData.actions">
        <ng-container
          *ngIf="headerData.visible && headerData.visible() && isActionGroup(button) && isActionVisible(button)">
          <span>
            <button class="btn btn-primary btn-xs pt-1 pb-1" (click)="menu.toggle($event);loadGroupActions (button);">
              {{ button.name |translate }} <i class="fa fa-cog dropdown-toggle" aria-hidden="true"></i>
            </button>
            <p-menu #menu [model]="groupActions" [popup]="true" appendTo="body"></p-menu>
          </span>
        </ng-container>
        <ng-container *ngIf="!isActionGroup(button)">
          <button appDebounceClick type="button"
            *ngIf="headerData.visible && headerData.visible() && isActionVisible(button) && button.type !== 'divider'"
            (debounceClick)="fireAction(button)" class="btn btn-sm {{ button.classes }}"
            title="{{ buttonTooltip(button) | translate }}" showDelay="1000" [disabled]="!isActionEnabled(button)">
            <i class="{{ button.icon }}" aria-hidden="true"></i><span class="d-none d-sm-inline"> {{ button.name |
              translate }}</span>
          </button>
        </ng-container>
        <div *ngIf="button.type === 'divider'" class="btn-group btn-divider" role="group"></div>
      </ng-container>
    </div>
  </div>
</div>
<!-- Si hay botones o ayuda que mostrar en la ventana-->
<div #headercontainer
  *ngIf="dataLoaded && isModal && (includeContextHelp || (headerData &&  headerData.windowactions && headerData.windowactions.get(windowHash)) )">
  <div class="title font-bold ml-5 mt-5" *ngIf="headerData &&  headerData.modalDescription"> {{
    headerData.modalDescription | translate }} </div>
  <div
    class="buttonsHeader {{includeContextHelp?'WithContextHelp':'WithoutContextHelp'}} {{(headerData && headerData.windowactions && headerData.windowactions.get(windowHash) && headerData.windowactions.get(windowHash).length>0)?'':'no-buttons'}}">
    <plyca-contextHelp *ngIf="includeContextHelp" [isModal]="true" class="float-left m-r-sm text-left">
    </plyca-contextHelp>
    <ng-container *ngIf="(headerData &&  headerData.windowactions && headerData.windowactions.get(windowHash))">
      <div class="buttonsHeaderPopup">
        <ng-container *ngFor="let button of headerData.windowactions.get(windowHash)">
          <ng-container *ngIf="isActionGroup(button) && isActionVisible(button)">
            <button class="btn btn-primary btn-xs pt-1 pb-1" (click)="menu.toggle($event);loadGroupActions (button);">
              <i class="fa fa-cog dropdown-toggle" aria-hidden="true"></i> {{ button.name |translate }}
            </button>
            <p-menu #menu [model]="groupActions" [popup]="true" appendTo="body"></p-menu>
          </ng-container>
          <button appDebounceClick type="button"
            *ngIf="button.visible && button.visible() && !isActionGroup(button) && button.type !== 'divider'"
            (debounceClick)="fireAction(button)" class="btn btn-sm {{ button.classes }}"
            title="{{ button.name | translate }}" showDelay="1000" [disabled]="!isActionEnabled(button)">
            <i class="{{ button.icon }}" aria-hidden="true"></i><span class="d-none d-sm-inline"> {{ button.name |
              translate }}</span>
          </button>
          <div *ngIf="button.type === 'divider'" class="btn-group btn-divider" role="group"></div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div class="m-t-xs">
    <dossierHeader *ngIf="headerData?.showProjectInModal && headerData?.project" [projectId]="headerData.project"
      [infoVisible]="false" [showDocumentsVisible]="false" [backVisible]="false" [favouriteVisible]="false"
      [showCalendarVisible]="false">
    </dossierHeader>
  </div>
</div>